import React from 'react';
import { styled } from '@linaria/react';

import useBoundingBox from '@/hooks/use-bounding-box';

import { DemoRadioControl } from '@/components/Demo';

import FlexDemo from './FlexDemo';
import Item from './Item';
import Output from './Output';
import CurlyBracket from './CurlyBracket';

const ITEM_WIDTH = 75;
// This number adds up things like padding / gap.
const HACKY_SUM = 16;

function FlexGrowIntro() {
  const headerRef = React.useRef();
  const headerBB = useBoundingBox(headerRef);

  let freeSpace = 0;

  if (headerBB) {
    freeSpace = headerBB.width - ITEM_WIDTH * 3 - HACKY_SUM;
  }

  return (
    <FlexDemo
      initialValues={{
        '--direction': 'row',
        flexGrow: 0,
      }}
      controls={[
        <DemoRadioControl
          key="--direction"
          id="--direction"
          label="flex-direction"
          options={['row', 'column']}
        />,
        <DemoRadioControl
          key="flexGrow"
          id="flexGrow"
          label="flex-grow"
          options={[{ label: '0 (default)', value: 0 }, 1]}
          wrapperStyle={{
            color: 'hsl(50deg 100% 65%)',
            fontWeight: 'var(--font-weight-medium)',
          }}
        />,
      ]}
    >
      {({ flexGrow, ...state }) => (
        <Wrapper>
          <Header ref={headerRef}>
            {freeSpace && (
              <FreeSpaceIndicator
                style={{
                  width: freeSpace,
                  opacity:
                    state['--direction'] === 'row' ? 1 - flexGrow : 0,
                }}
              >
                <Label>Extra Space</Label>
                <CurlyBracket />
              </FreeSpaceIndicator>
            )}
          </Header>
          <Output state={state}>
            <Item
              primary
              style={{ flexBasis: ITEM_WIDTH, flexGrow: flexGrow }}
            />
            <Item style={{ flexBasis: ITEM_WIDTH }} />
            <Item style={{ flexBasis: ITEM_WIDTH }} />
          </Output>
        </Wrapper>
      )}
    </FlexDemo>
  );
}

const Wrapper = styled.div``;

const Header = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const FreeSpaceIndicator = styled.div`
  padding-right: 2px;
  padding-bottom: 4px;
  text-align: center;
  transition: opacity 200ms;
`;
const Label = styled.span`
  display: block;
  font-size: 0.875rem;
  line-height: 1.2;
  margin-bottom: 7px;
  color: var(--color-text);
  font-weight: var(--font-weight-medium);
`;

export default FlexGrowIntro;
